const env = (key: string) => (import.meta as any)?.env?.[key] as string | undefined;

const TENANT_STORAGE_KEY = 'profitibull_tenant_id';
const DEFAULT_TENANT_ID = 'solo';
const TENANT_ID_PATTERN = /^[a-z0-9][a-z0-9-]{1,62}$/;

function normalizeTenantId(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim().toLowerCase();
  if (!trimmed) return null;
  if (!TENANT_ID_PATTERN.test(trimmed)) return null;
  return trimmed;
}

function readTenantFromStorage(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return normalizeTenantId(window.localStorage.getItem(TENANT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function getTenantId(): string {
  return (
    normalizeTenantId(env('VITE_TENANT_ID')) ??
    readTenantFromStorage() ??
    DEFAULT_TENANT_ID
  );
}

export function getTenantHeaders(headers?: HeadersInit): Record<string, string> {
  const base = new Headers(headers ?? {});
  base.set('x-tenant-id', getTenantId());
  return Object.fromEntries(base.entries());
}

export function appendTenantQuery(params: URLSearchParams): URLSearchParams {
  params.set('tenantId', getTenantId());
  return params;
}
